import $ from 'jquery'
import { alert_error, post_json,
         get_myinfo, has_user_loggedin } from '../common'

$(init)

async function init () {
  let $page = $('#contact-page')
  if ($page.length == 0) {
    return
  }
  let $form = $('#contactform')
  $form.on('submit', async ($evt) => {
    $evt.preventDefault()
    try {
      let data = {}
      for (let field of ['email','name','reason','message']) {
        data[field] = $(`#contactform [name=${field}]`).val()
      }
      await post_json('/messages/create', data)
      $('#contactform').addClass('d-none')
      $('#thankyou-sect').removeClass('d-none')
    } catch (err) {
      alert_error(err)
    }
  })
  let myinfo = await get_myinfo()
  let loggedin = has_user_loggedin(myinfo)
  if (loggedin) {
    $form.find('[name=name]').val(myinfo.name)
    $form.find('[name=email]').val(myinfo.email)
  } else {
    for (let option of $form.find('[name=reason] option')) {
      if (option.value == 'refund') {
        option.parentNode.removeChild(option)
      }
    }
  }
  $page.removeClass('page-not-ready').addClass('page-ready')
}

